module.exports = __webpack_public_path__ + "media/images/tutors/PrepWorks-Yee-Wan-Ting-7dba539abcf09b436e323fb667a7fdad.jpg";